// Libs
import subDays from 'date-fns/subDays';
// App
import { formatDate } from 'app-shared/lib/utils/date.utils';
import { PriceOptions } from 'app-shared/lib/components/cards/shared/price/price.interfaces';
import { DiscountableProduct } from './discountable-product.interface';

/**
 * The discounted price comes from the API, which alone applies the percentage, so that the bag never differs from the order.
 */
export const isProductOnDiscount = (product: DiscountableProduct): boolean => {
  const isOnDiscount: boolean = product.discountedPrice != null;

  return isOnDiscount;
};

export const getSellingPrice = (product: DiscountableProduct): number => {
  const sellingPrice: number = (isProductOnDiscount(product) && product.discountedPrice) || product.price;

  return sellingPrice;
};

export const buildDiscountPriceOptions = (
  product: DiscountableProduct
): Pick<PriceOptions, 'originalPrice' | 'discountPercent'> => {
  const isOnDiscount: boolean = isProductOnDiscount(product);
  const discountPriceOptions: Pick<PriceOptions, 'originalPrice' | 'discountPercent'> = {
    originalPrice: (isOnDiscount && product.price) || undefined,
    discountPercent: (isOnDiscount && product.discountPercent) || undefined,
  };

  return discountPriceOptions;
};

/**
 * The end date of a promotion is excluded: a promotion running until the 15th ends on the 16th at midnight.
 */
export const formatProductDiscountLastDay = (discountEndDate: string): string => {
  const lastDay: string = formatDate(subDays(new Date(discountEndDate), 1), 'dd/MM');

  return lastDay;
};
